@if (formType === 'daterange-picker') {
  <div class="fip-form__daterange-picker">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

@if (formType === 'input') {
  <div class="fip-form__input">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

@if (formType === 'submit') {
  <div class="fip-form__submit">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

@if (formType === 'slide') {
  <div class="fip-form__slide">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<ng-template #content><ng-content></ng-content></ng-template>
